<template id="payment-summary">
    <div :class="[ ((bill == 'digitale')&&(payment == 'addebito diretto')) ? 'summary discount-active' : 'summary' ]" >
        
        <div class="detail">
            <div class="summary-title">CORRISPETTIVI * <!-- LINK {{ supply }} --></div>
            
            <!-- Luce 24h (monoraria) -->
            <div class="row" v-if="fare == 'monoraria'">
                <div class="col-xs-6">
                    <div>
                        <span class="fare-name">LUCE 24h</span>

                        <div class="tooltip-step">
                            <span class="tooltiptext tooltip-right">
                                <strong>Monoraria:</strong> 24h <br/> tutti i giorni
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="(((bill == 'digitale')&&(payment == 'addebito diretto'))||(paymentsetup == 'fare-setup'))" class="col-xs-6 fare-price">
                    <div>  
                        <span class="price">{{ secondPrice(f) }} </span>
                        <span class="unit">€/kWh</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ firstPrice(f) }}</div>
                </div>
                <div v-else class="col-xs-6 fare-price">
                    <div>  
                        <span class="price">{{ formatPrice(f) }} </span>
                        <span class="unit">€/kWh</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ thirdPrice(f) }}</div>
                </div>
            </div>

            <!-- Luce F1 (bioraria) -->
            <div class="row" v-if="fare == 'bioraria'">
                <div class="col-xs-6">
                    <div>
                        <span class="fare-name">LUCE F1</span>

                        <div class="tooltip-step">
                            <span class="tooltiptext tooltip-right">
                                <strong>F1</strong>: 8:00 - 19:00 <br/> lun-ven escluse festività
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="(((bill == 'digitale')&&(payment == 'addebito diretto'))||(paymentsetup == 'fare-setup'))" class="col-xs-6 fare-price">
                    <div>  
                        <span class="price">{{ secondPrice(f1) }} </span>
                        <span class="unit">€/kWh</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ firstPrice(f1) }}</div>
                </div>
                <div v-else class="col-xs-6 fare-price">
                    <div>  
                        <span class="price">{{ formatPrice(f1) }} </span>
                        <span class="unit">€/kWh</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ thirdPrice(f1) }}</div>
                </div>
            </div>

            <!-- Luce F2-F3 (bioraria) -->
            <div class="row" v-if="fare == 'bioraria'">
                <div class="col-xs-6">
                    <div>
                        <span class="fare-name">LUCE F2-F3</span>

                        <div class="tooltip-step">
                            <span class="tooltiptext tooltip-right">
                                <strong>F2-F3</strong>: 19:00 - 08:00 <br/> weekend e festività
                            </span>
                        </div>
                    </div>



                </div>

                <div v-if="(((bill == 'digitale')&&(payment == 'addebito diretto'))||(paymentsetup == 'fare-setup'))" class="col-xs-6 fare-price">
                    <div>
                        <span class="price">{{ secondPrice(f2) }} </span>
                        <span class="unit">€/kWh</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ firstPrice(f2) }}</div>
                </div>

                <div v-else class="col-xs-6 fare-price">
                    <div>
                        <span class="price">{{ formatPrice(f2) }} </span>
                        <span class="unit">€/kWh</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ thirdPrice(f2) }}</div>
                </div>

            </div>

            <!-- GAS -->
            <div class="row" v-if="(supply == 'GAS')||(supply == 'GAS E LUCE')">
                <div class="col-xs-6">
                    <div><span class="fare-name">GAS</span></div>
                </div>
                <div v-if="(((bill == 'digitale')&&(payment == 'addebito diretto'))||(paymentsetup == 'fare-setup'))" class="col-xs-6 fare-price">
                    <div>
                        <span class="price">{{ secondPrice(gas) }} </span> 
                        <span class="unit">€/Smc</span>
                    </div>
                    <div class="secondyear">dal 2° anno {{ firstPrice(gas) }}</div>
                </div>
                <div v-else class="col-xs-6 fare-price">
                    <div>
                        <span class="price">{{ formatPrice(gas) }} </span> 
                        <span class="unit">€/Smc</span>
                    </div>
                    <!-- CAPIRE PERCHE' NON FUNZIONA QUESTA VERSIONE <div class="secondyear">dal 2° anno {{ gas, 4 }}</div> -->
                    <div class="secondyear">dal 2° anno {{ thirdPrice(gas) }}</div>
                </div>
            </div>
            
        </div>
        <div v-if="paymentsetup == 'payment-setup'" class="discount">
            <div v-if="((bill == 'digitale')&&(payment == 'addebito diretto'))">
                <div class="info">
                    <span class="icon icon-check"></span>
                    SCONTO DIGITALE ATTIVO.
                </div>
            </div>
            <div v-else>
                <div class="info">
                    <span class="icons">
                        <span class="icon icon-CC-bancario"></span>
                        +
                        <span class="icon icon-bollette-digitale"></span>
                    </span>
                    RISPARMIA CON LO SCONTO DIGITALE
                </div>
                <div class="explanation">Per usufruire dello sconto digitale è necessario impostare<br> l’addebito diretto e la bolletta digitale.</div>
            </div>
        </div>

        <div v-else-if="paymentsetup == 'fare-setup'" class="fare-info">
            <p>Se non sai cosa scegliere, non ti preoccupare. La scelta di un profilo non adatto alle tue abitudini di consumo ha un impatto molto limitato sulla tua bolletta, meno di 2€ al mese per un’abitazione con un consumo standard (2.700 kWh all’anno).</p>
            <p>* I prezzi mostrati si intendono già al netto dello sconto digitale: scegli l’Addebito su conto corrente e la Bolletta digitale per riceverlo.</p>
        </div>
    </div>
</template>

<script>
export default {
    template: '#payment-summary',
    
    props: ['stepid', 'fare', 'payment', 'bill', 'paymentsetup', "f", "f1", "f2", "gas"],
    data: function () {
        return {
            value: -1
        };
    },

    created: function () {
        this.value = -1;

        // individuazione commodity
        switch (this.stepid[1]){
            case "1":
                    this.supply = "GAS E LUCE";
                break;
            case "2":
                    this.supply = "LUCE";
            break;
            case "3":
                    this.supply = "GAS";
            break;
        }

        // tariffe standard vecchie
        /*
        this.luce_mono = 0.0644;
        this.luce_f1 = 0.0690;
        this.luce_f2f3 = 0.0621;
        this.gas = 0.2290;
        */

        // tariffe standard nuove
        //this.luce_mono = 0.05535;   // ex 0.0615
        // this.luce_mono = 0.0615;   // ex 0.0615
        // //this.luce_f1 = 0.0593;      // ex 0.0659
        // this.luce_f1 = 0.0659;      // ex 0.0659
        // //this.luce_f2f3 = 0.0534;    // ex 0.0593
        // this.luce_f2f3 = 0.0593;    // ex 0.0593
        // // this.gas = 0.2190;

        // this.sconto10 = 0.9;
        // this.sconto20 = 0.8;

        // // tariffe sconto 10%
        // this.luce_mono_sconto10 = this.siDec(this.luce_mono*this.sconto10, 4);
        // this.luce_f1_sconto10 = this.siDec(this.luce_f1*this.sconto10, 4);
        // this.luce_f2f3_sconto10 = this.siDec(this.luce_f2f3*this.sconto10, 4);
        // this.gas_sconto10 = this.siDec(this.gas*this.sconto10, 4);

        // // tariffe sconto 20%  
        // this.luce_mono_sconto20 = this.siDec(this.luce_mono*this.sconto20, 4);
        // this.luce_f1_sconto20 = this.siDec(this.luce_f1*this.sconto20, 4);
        // this.luce_f2f3_sconto20 = this.siDec(this.luce_f2f3*this.sconto20, 4);
        // this.gas_sconto20 = this.siDec(this.gas*this.sconto20, 4);      

        // // tariffe standard con virgola al posto del punto  
        // this.luce_mono_dec = this.siDec(this.luce_mono, 4);
        // this.luce_f1_dec = this.siDec(this.luce_f1, 4);
        // this.luce_f2f3_dec = this.siDec(this.luce_f2f3, 4);
        // this.gas_dec = this.siDec(this.gas, 4);     
    },
    beforeMount: function () {
        this.value = -1;
    },
    methods: {
        siDec: function(x, decimals) {   // Sistema Internazionale Unità di Misura con numero di decimali variabile
            return x.toFixed(decimals).replace('.', ',');
        },

        formatPrice: function(price) {
            return price.toFixed(4).replace(".", ",").replace(/[.,]*(000+)$/g, "");
        },

        firstPrice: function(price) {
            let discount = price / 100 * 70;
            discount = Math.round(discount * 10000) / 10000;
            return discount.toFixed(4).replace(".", ",").replace(/[.,]*(000+)$/g, "");
        },

        secondPrice: function(price) {
            let discount = price / 100 * 90;
            discount = Math.round(discount * 10000) / 10000;
            return discount.toFixed(4).replace(".", ",").replace(/[.,]*(000+)$/g, "");
        },

        thirdPrice: function(price) {
            let discount = price / 100 * 80;
            discount = Math.round(discount * 10000) / 10000;
            return discount.toFixed(4).replace(".", ",").replace(/[.,]*(000+)$/g, "");
        }
    }
}
</script>